import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { AdminBuyerListQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";

const adminBuyerListQuery = graphql(`
  query adminBuyerList($id: String!) {
    adminBuyerList(id: $id) {
      id
      name
      ownerId
      companyId
      sharingType
      createdAt
      updatedAt
      isDeleted
      entries {
        id
        name
      }
    }
  }
`);

/** Fetch a single buyer list by ID (admin — no RBAC check). */
export function useAdminBuyerList(
  id: string,
  options?: UseQueryOptions<AdminBuyerListQuery, unknown, AdminBuyerListQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["buyerList", id],
    adminBuyerListQuery,
    [{ id }],
    options,
  );
  return { data: data?.adminBuyerList, ...rest };
}
